module.exports = __webpack_public_path__ + "img/category-4.9fcd057b.svg";